import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
        this.handle_time_update = this.handle_time_update.bind(this);
        this.handle_mute_click = this.handle_mute_click.bind(this);
        this.handle_skip_click = this.handle_skip_click.bind(this);
    }

    init() {
        // Select DOM elements
        this.video = this.el.querySelector('.js-video');
        // this.buttonMute = this.el.querySelector('.js-mute');
        this.buttonSkip = this.el.querySelector('.js-skip');
        this.html = document.querySelector('html');

        // Configuration and states
        this.videoDuration = this.video.duration;
        this.video.volume = 0.1;
        this.video.muted = true;

        this.controls_ready_class = 'controls-ready';
        this.video_ready_class = 'video-ready';
        this.has_intro_class = 'has-intro';

        // Initialize mute button state
        // this.buttonMute.classList.add('is-muted');

        // Check for existing cookie to skip intro
        if (this.get_cookie('intro_skipped')) {
            this.remove_intro();
            return;
        }

        // Initialize controls if intro is present
        if (this.html.classList.contains(this.has_intro_class)) {
            setTimeout(() => {
                this.el.classList.add(this.controls_ready_class);
            }, 600);
        }

        // Video ready state handling
        if (this.video.readyState === 4) {
            this.handle_video_loaded();
        } else {
            setTimeout(() => {
                this.handle_video_loaded();
            }, 300);
        }

        // Event listeners
        this.video.addEventListener('timeupdate', this.handle_time_update);
        // this.buttonMute.addEventListener('click', this.handle_mute_click);
        this.buttonSkip.addEventListener('click', this.handle_skip_click);
    }

    handle_video_loaded() {
        this.el.classList.add(this.video_ready_class);
        this.video.play();
    }

    handle_time_update() {
        if (this.video.currentTime >= this.videoDuration - 2) {
            this.set_cookie('intro_skipped', 'true'); // Set cookie when video ends
            this.cleanup_video();
            this.video.removeEventListener('timeupdate', this.handle_time_update);
        }
    }

    handle_mute_click() {
        this.video.muted = !this.video.muted;
        // this.buttonMute.classList.toggle('is-muted');
    }

    handle_skip_click() {
        this.video.muted = true;
        this.set_cookie('intro_skipped', 'true'); // Set cookie when video is skipped
        this.cleanup_video();
    }

    cleanup_video() {
        this.el.classList.remove(this.video_ready_class, this.controls_ready_class);
        setTimeout(() => {
            this.html.classList.remove(this.has_intro_class);
            setTimeout(() => {
                this.html.classList.remove('delay-anims');
            }, window.transitionDelay);
        }, 1500);
        setTimeout(() => {
            this.video.pause();
        }, 3000);
    }

    remove_intro() {
        // Remove intro immediately if cookie is active
        this.html.classList.remove(this.has_intro_class);
        this.el.classList.remove(this.video_ready_class, this.controls_ready_class);
        this.video.pause();

        setTimeout(() => {
            this.html.classList.remove('delay-anims');
        }, window.transitionDelay);

        this.call('resumeAutoplay', 'Slider');
    }

    set_cookie(name, value) {
        document.cookie = `${name}=${value}; path=/`;
    }

    get_cookie(name) {
        const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }

    destroy() {
        // Remove all event listeners
        this.video.removeEventListener('timeupdate', this.handle_time_update);
        // this.buttonMute.removeEventListener('click', this.handle_mute_click);
        this.buttonSkip.removeEventListener('click', this.handle_skip_click);

        // Stop video and clean up styles
        this.video.pause();
        this.video.muted = true;
        this.el.classList.remove(this.video_ready_class, this.controls_ready_class);
        this.html.classList.remove(this.has_intro_class);
    }
}
